<template>
  <ModalWindow :show-modal="showModal" @closeModal="$emit('closeModal')">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content text-white bg-secondary">
        <div class="modal-header border-bottom-0">
          <h5 class="modal-title">Importation d'un sondage</h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            @click="$emit('closeModal')"
          ></button>
        </div>
        <div class="modal-body">
          <form novalidate class="needs-validation">
            <input
              v-model="form.surveyToken"
              type="text"
              class="form-control text-center w-100"
              :class="getValidationClass('surveyToken')"
              placeholder="Entrez le jeton de 6 caractères"
              required
            />
            <div v-if="form.errors.surveyToken" class="invalid-feedback">
              {{ form.errors.surveyToken }}
            </div>
          </form>
        </div>
        <div class="modal-footer border-top-0">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="form.processing"
            @click="importSurvey()"
          >
            Importer
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            @click="$emit('closeModal')"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  </ModalWindow>
</template>

<script>
import ModalWindow from './ModalWindow.vue'

export default {
  components: { ModalWindow },
  props: {
    showModal: Boolean,
  },
  emits: ['closeModal'],
  data() {
    return {
      wasValidatedOnce: false,
      form: this.$inertia.form({
        surveyToken: null,
      }),
    }
  },
  methods: {
    importSurvey() {
      this.wasValidatedOnce = false
      this.$toasted.global.import()
      this.form.post(this.$route('survey.user.import'), {
        onSuccess: () => {
          this.$emit('closeModal')
          this.$toasted.global.imported()
        },
        onFinish: () => (this.wasValidatedOnce = true),
      })
    },
    getValidationClass(key) {
      return this.form.errors[key] && this.wasValidatedOnce
        ? 'is-invalid'
        : null
    },
  },
}
</script>
